import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import gbr1 from '../assets/HOME DASHBOARD/HSSE DASHBOARD.png';
import gbr2 from '../assets/HOME DASHBOARD/HSSE REGULATORY.png';
import gbr3 from '../assets/HOME DASHBOARD/INCIDENT MANAGEMENT.png';
import gbr4 from '../assets/HOME DASHBOARD/PATUH.png';
import gbr5 from '../assets/HOME DASHBOARD/RISK MANAGEMENT.png';
import gbr6 from '../assets/HOME DASHBOARD/HSSE DOCUMENT.png';
import { Button, IconButton, Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import SnackAlert from '../components/Dashboard/SnackAlert';
import DialogIncidentAlert from '../components/Dashboard/DialogIncidentAlert';
import DialogCustom from '../components/DialogCustom';
import { useAuth } from 'oidc-react';
// import swal from 'sweetalert';

const Home = () => {
  const history = useNavigate();
  const { userData } = useAuth();

  const hsseClick = () => {
    history('/hsse/action-tracking');
  };
  const Incident = () => {
    // if (user === 'user1@mail.com') {
    //     history('/hsse/incident/user');
    // } else if (user === 'Reviewer Lokasi') {
    //     history('/hsse/incident/reviewlokasi');
    // } else if (user === 'Reviewer Unit') {
    //     history('/hsse/incident/reviewunit');
    // } else if (user === 'Reviewer HSSE') {
    //     history('/hsse/incident/reviewhsse');
    // } else if (user === 'Reviewer VP') {
    //     history('/hsse/incident/reviewvpasset');
    // } else if (user === 'Approver') {
    //     history('/hsse/incident/approval');
    // } else {
    //     swal({
    //         title: "Gagal Masuk",
    //         text: "User tidak terdaftar!",
    //         icon: "danger",
    //         button: "Ok",
    //     }).then(history('/hsse'));
    // }
    history('/hsse/incident/dashboardlkp');
  };
  const regulatory = () => {
    history('/hsse/regulatory');
  };
  const patuh = () => {
    history('/hsse/patuh');
  };
  const risk = () => {
    history('/hsse/risk');
  };
  const dokumen = () => {
    history('/hsse/document');
  };

  // Snackbar
  const [snackOpen, setSnackOpen] = useState(true);
  const [snackMessage, setSnackMessage] = useState('');
  const closeSnack = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackOpen(false);
  };
  const openSnack = (message) => {
    setSnackMessage(message);
    setSnackOpen(true);
  };

  // Dialog
  const [dialogOpen, setDialogOpen] = useState(false);
  const handleOpenDialog = () => {
    setDialogOpen(true);
    setSnackOpen(false);
  };
  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const [sendLoad, setSendLoad] = useState(false);
  const handleSend = () => {
    setSendLoad(true);

    const tm = setTimeout(() => {
      //// Jika Berhasil
      setDialogOpen(false);
      setOpen2(true);

      //// Jika Gagal
      // setOpen3(true);
      // setSendLoad(false);

      clearTimeout(tm);
    }, 2000);
  };

  // Dialog Save Berhasil
  const [open2, setOpen2] = useState(false);
  const handleClose2 = () => {
    setOpen2(false);
  };

  // Dialog Save Gagal
  const [open3, setOpen3] = useState(false);
  const [failMessage, setFailMessage] = useState('');
  const handleClose3 = () => {
    setOpen3(false);
  };

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{ minHeight: '70vh', cursor: 'pointer' }}
    >
      <Grid item xs={3}>
        <p>Anda login sebagai {userData?.profile?.display_name}</p>
        <Stack spacing={2} direction="row">
          <Box
            sx={{
              position: 'relative',
              display: 'inline-block',
            }}
          >
            <Box
              component="img"
              sx={{
                height: '200px',
                width: '200px',
                maxHeight: { xs: '200px', md: '200px' },
                maxWidth: { xs: '200px', md: '200px' },
                border: 1,
                borderRadius: 5,
                boxShadow: 5,
                borderColor: 'lightgrey',
                backgroundColor: 'primary.dark',
                '&:hover': {
                  backgroundColor: 'primary.main',
                  opacity: [0.9, 0.8, 0.7],
                },
              }}
              alt="Pic 1"
              src={gbr1}
              onClick={hsseClick}
            />
            <Box
              sx={{
                position: 'absolute',
                bottom: '10px',
                left: '5px',
                width: '96%',
                padding: '20px 10px',
                fontSize: '14px',
                textAlign: 'center',
                borderRadius: 5,
                backgroundColor: 'white',
              }}
              onClick={hsseClick}
            >
              Action Tracking
            </Box>
          </Box>
          <Box
            sx={{
              position: 'relative',
              display: 'inline-block',
            }}
          >
            <Box
              component="img"
              sx={{
                height: '200px',
                width: '200px',
                maxHeight: { xs: '200px', md: '200px' },
                maxWidth: { xs: '200px', md: '200px' },
                border: 1,
                borderRadius: 5,
                boxShadow: 5,
                borderColor: 'lightgrey',
                backgroundColor: 'primary.dark',
                '&:hover': {
                  backgroundColor: 'primary.main',
                  opacity: [0.9, 0.8, 0.7],
                },
              }}
              alt="Pic 2"
              src={gbr2}
              onClick={regulatory}
            />
            <Box
              sx={{
                position: 'absolute',
                bottom: '10px',
                left: '5px',
                width: '96%',
                padding: '20px 10px',
                fontSize: '14px',
                textAlign: 'center',
                borderRadius: 5,
                backgroundColor: 'white',
              }}
              onClick={regulatory}
            >
              HSSE Regulatory Compliance
            </Box>
          </Box>
          <Box
            sx={{
              position: 'relative',
              display: 'inline-block',
            }}
          >
            <Box
              component="img"
              sx={{
                height: '200px',
                width: '200px',
                maxHeight: { xs: '200px', md: '200px' },
                maxWidth: { xs: '200px', md: '200px' },
                border: 1,
                borderRadius: 5,
                boxShadow: 5,
                borderColor: 'lightgrey',
                backgroundColor: 'primary.dark',
                '&:hover': {
                  backgroundColor: 'primary.main',
                  opacity: [0.9, 0.8, 0.7],
                },
              }}
              alt="Pic 3"
              src={gbr4}
              onClick={patuh}
            />
            <Box
              sx={{
                position: 'absolute',
                bottom: '10px',
                left: '5px',
                width: '96%',
                padding: '20px 10px',
                fontSize: '14px',
                textAlign: 'center',
                borderRadius: 5,
                backgroundColor: 'white',
              }}
              onClick={patuh}
            >
              PATUH
            </Box>
          </Box>
        </Stack>
        <br></br>
        <Stack spacing={2} direction="row">
          <Box
            sx={{
              position: 'relative',
              display: 'inline-block',
            }}
          >
            <Box
              component="img"
              sx={{
                height: '200px',
                width: '200px',
                maxHeight: { xs: '200px', md: '200px' },
                maxWidth: { xs: '200px', md: '200px' },
                border: 1,
                borderRadius: 5,
                boxShadow: 5,
                borderColor: 'lightgrey',
                backgroundColor: 'primary.dark',
                '&:hover': {
                  backgroundColor: 'primary.main',
                  opacity: [0.9, 0.8, 0.7],
                },
              }}
              alt="Pic insiden"
              src={gbr3}
              onClick={Incident}
            />
            <Box
              sx={{
                position: 'absolute',
                bottom: '10px',
                left: '5px',
                width: '96%',
                padding: '20px 10px',
                fontSize: '14px',
                textAlign: 'center',
                borderRadius: 5,
                backgroundColor: 'white',
              }}
              onClick={Incident}
            >
              Incident Management
            </Box>
          </Box>
          <Box
            sx={{
              position: 'relative',
              display: 'inline-block',
            }}
          >
            <Box
              component="img"
              sx={{
                height: '200px',
                width: '200px',
                maxHeight: { xs: '200px', md: '200px' },
                maxWidth: { xs: '200px', md: '200px' },
                border: 1,
                borderRadius: 5,
                boxShadow: 5,
                borderColor: 'lightgrey',
                backgroundColor: 'primary.dark',
                '&:hover': {
                  backgroundColor: 'primary.main',
                  opacity: [0.9, 0.8, 0.7],
                },
              }}
              alt="Pic 5"
              src={gbr5}
              onClick={risk}
            />
            <Box
              sx={{
                position: 'absolute',
                bottom: '10px',
                left: '5px',
                width: '96%',
                padding: '20px 10px',
                fontSize: '14px',
                textAlign: 'center',
                borderRadius: 5,
                backgroundColor: 'white',
              }}
              onClick={risk}
            >
              Risk Management
            </Box>
          </Box>
          <Box
            sx={{
              position: 'relative',
              display: 'inline-block',
            }}
          >
            <Box
              component="img"
              sx={{
                height: '200px',
                width: '200px',
                maxHeight: { xs: '200px', md: '200px' },
                maxWidth: { xs: '200px', md: '200px' },
                border: 1,
                borderRadius: 5,
                boxShadow: 5,
                borderColor: 'lightgrey',
                backgroundColor: 'primary.dark',
                '&:hover': {
                  backgroundColor: 'primary.main',
                  opacity: [0.9, 0.8, 0.7],
                },
              }}
              alt="Pic 6"
              src={gbr6}
              onClick={dokumen}
            />
            <Box
              sx={{
                position: 'absolute',
                bottom: '10px',
                left: '5px',
                width: '96%',
                padding: '20px 10px',
                fontSize: '14px',
                textAlign: 'center',
                borderRadius: 5,
                backgroundColor: 'white',
              }}
              onClick={dokumen}
            >
              HSSE Document
            </Box>
          </Box>
        </Stack>
      </Grid>

      {/* Snack */}
      {/* <SnackAlert snackOpen={snackOpen} handleOpenDialog={handleOpenDialog} /> */}

      {/* Dialog */}
      {/* <DialogIncidentAlert
        dialogOpen={dialogOpen}
        handleSend={handleSend}
        sendLoad={sendLoad}
        handleCloseDialog={handleCloseDialog}
      /> */}

      {/* Dialog Save Berhasil */}
      <DialogCustom
        open={open2}
        handleClose={handleClose2}
        title={
          <>
            Notifikasi
            {handleClose2 ? (
              <IconButton
                aria-label="close"
                onClick={handleClose2}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
          </>
        }
        content={<>Data berhasil terkirim</>}
      />

      {/* Dialog Save GAGAL */}
      <DialogCustom
        open={open3}
        handleClose={handleClose3}
        title={
          <>
            Notifikasi
            {handleClose3 ? (
              <IconButton
                aria-label="close"
                onClick={handleClose3}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
          </>
        }
        content={
          <>
            Data gagal terkirim
            <br />
            Silahkan coba beberapa saat lagi
          </>
        }
        actions={
          <>
            <Button onClick={handleClose3} autoFocus variant="contained">
              Tutup
            </Button>
          </>
        }
      />
    </Grid>
  );
};

export default Home;
